<template>
  <div class="col-md-6 col-lg-4 mediumStudio flex-column" :class="index > 4 ? 'd-none d-lg-flex' : index > 3 ? 'd-none d-md-flex' : 'd-flex'">
    <ImageSlider :images="images" />
    <div class="mediumStudioSummary">
      <a class="studioName d-block" :href="`/studio-detail/?id=${studioInfo.studio_id}`">
        {{ studioInfo.studio_name }}
      </a>
      <div class="studioTags">
        <a v-for="item in studioTagInfo" :key="item.tag_id" :href="`/studio-list/?search_tag=${item.tag_id}`"> #{{ item.name }} </a>
      </div>
    </div>
    <div class="mediumStudioSpacer flex-grow-1"></div>
    <div class="mediumStudioContents">
      <ListIcons :flags="flags" />
      <ul class="nav nav-tabs studioTabs nav-fill" :id="`Tab${count + sort}`">
        <li class="nav-item" role="presentation">
          <a class="nav-link active" data-toggle="tab" :href="`#overview${count + sort}`" aria-selected="true"> 概要 </a>
        </li>
        <li class="nav-item" role="presentation">
          <a class="nav-link" id="profile-tab" data-toggle="tab" :href="`#profile${count + sort}`" aria-selected="false"> 使用料 </a>
        </li>
        <li class="nav-item" role="presentation">
          <a class="nav-link" id="contact-tab" data-toggle="tab" :href="`#contact${count + sort}`" aria-selected="false"> 詳細説明 </a>
        </li>
      </ul>
      <div class="tab-content" :id="`Tab${count + sort}Content`">
        <div class="tab-pane fade fadeIn show active" :id="`overview${count + sort}`">
          <table class="table table-borderless">
            <tr>
              <th class="px-0 text-center" style="width: 20px"><img :src="`${imgPath}/images/clock.svg`" /></th>
              <td>利用可能時間 : {{ studioInfo.available_start_time }}~{{ studioInfo.available_end_time }}</td>
            </tr>
            <tr v-if="studioInfo.closest_station_name">
              <th class="px-0 text-center" style="width: 20px"><img :src="`${imgPath}/images/train.svg`" /></th>
              <td>最寄駅 : {{ studioInfo.closest_station_name }}から徒歩{{ studioInfo.distance_station }}分</td>
            </tr>
            <tr>
              <th class="px-0 text-center" style="width: 20px"><img :src="`${imgPath}/images/map.svg`" /></th>
              <td>{{ studioInfo.prefecture }}{{ studioInfo.city }}{{ studioInfo.building_etc }}</td>
            </tr>
            <tr class="hoverArea">
              <th class="px-0 text-center" style="width: 20px"><img :src="`${imgPath}/images/mail.svg`" /></th>
              <td class="d-flex justify-content-between">
                <div>
                  <a v-if="studioInfo.contact_url" :href="studioInfo.contact_url" target="_blank"> お問い合わせフォーム </a>
                  <a v-else-if="studioInfo.contact_mail" :href="`mailto:${studioInfo.contact_mail}`">
                    {{ studioInfo.contact_mail }}
                  </a>
                  <a v-else @click="click" class="trigger"> お問い合わせはこちら </a>
                </div>
                <div>
                  <div class="hoverCopy">
                    <a v-if="studioInfo.contact_url" :href="studioInfo.contact_url" target="_blank">
                      <img :src="`${imgPath}/images/hoverLink.svg`" />
                    </a>
                    <a v-else-if="studioInfo.contact_mail" :href="`mailto:${studioInfo.contact_mail}`">
                      <img :src="`${imgPath}/images/hoverLink.svg`" />
                    </a>
                    <a v-if="studioInfo.contact_url" @click="copy(studioInfo.contact_mail, 'copyMail' + count + sort)">
                      <img :src="`${imgPath}/images/hoverCopy.svg`" />
                    </a>
                    <a v-else-if="studioInfo.contact_mail" @click="copy(studioInfo.contact_mail, 'copyMail' + count + sort)">
                      <img :src="`${imgPath}/images/hoverCopy.svg`" />
                    </a>
                    <a v-else @click="click" class="trigger">
                      <img :src="`${imgPath}/images/hoverLink.svg`" />
                    </a>
                    <span :id="`copyMail${count + sort}`" class="copyOk">Copy</span>
                  </div>
                </div>
              </td>
            </tr>
            <!-- <tr class="hoverArea">
              <th class="px-0 text-center" style="width: 20px"><img :src="`${imgPath}/images/tell.svg`" /></th>
              <td class="d-flex justify-content-between">
                <div>
                  <a v-if="studioInfo.contact_tel" :href="`tel:${studioInfo.contact_tel}`">
                    {{ studioInfo.contact_tel }}
                  </a>
                  <a v-else href="tel:03-5545-5523"> 03-5545-5523 </a>
                </div>
                <div>
                  <div class="hoverCopy">
                    <a v-if="studioInfo.contact_tel" :href="`tel:${studioInfo.contact_tel}`">
                      <img :src="`${imgPath}/images/hoverPhone.svg`" />
                    </a>
                    <a v-else href="tel:03-5545-5523">
                      <img :src="`${imgPath}/images/hoverPhone.svg`" />
                    </a>
                    <a v-if="studioInfo.contact_tel" @click="copy(studioInfo.contact_tel, 'copyTel' + count + sort)">
                      <img :src="`${imgPath}/images/hoverCopy.svg`" />
                    </a>
                    <a v-else @click="copy('03-5545-5523', 'copyTel' + count + sort)">
                      <img :src="`${imgPath}/images/hoverCopy.svg`" />
                    </a>
                    <span :id="`copyTel${count + sort}`" class="copyOk">Copy</span>
                  </div>
                </div>
              </td>
            </tr> -->
          </table>
        </div>
        <div class="tab-pane fade fadeIn" :id="`profile${count + sort}`">
          <table class="table table-borderless">
            <tr>
              <td></td>
              <td>{{ studioInfo.basic_charge1_head }}</td>
              <td>{{ studioInfo.basic_charge2_head }}</td>
            </tr>
            <tr>
              <td style="white-space: nowrap">基本料金</td>
              <td>{{ studioInfo.basic_charge1 }}</td>
              <td>{{ studioInfo.basic_charge2 }}</td>
            </tr>
            <tr v-if="studioInfo.reserved_remarks">
              <td style="white-space: nowrap">一日貸し切り</td>
              <td colspan="2">{{ studioInfo.reserved_remarks }}</td>
            </tr>
            <tr>
              <td style="white-space: nowrap">清掃費</td>
              <td colspan="2">{{ studioInfo.basic_charge3 }}</td>
            </tr>
          </table>
        </div>
        <div class="tab-pane fade fadeIn" :id="`contact${count + sort}`">
          <p>{{ studioInfo.s_description }}</p>
        </div>
      </div>
    </div>
    <transition name="fade">
      <ContactForm
        v-if="isOpen"
        @close="click"
        :nonce="nonce"
        :studioId="studioInfo.studio_id"
        :studioName="studioInfo.studio_name"
        :imgPath="imgPath"
        :postUrl="postUrl"
      />
    </transition>
  </div>
</template>
<script>
import ContactForm from "../../components/ContactForm.vue";
import ListIcons from "../../components/ListIcons.vue";
import ImageSlider from "../../components/ImageSlider.vue";

export default {
  name: "IndexList",
  components: {
    ImageSlider,
    ContactForm,
    ListIcons,
  },
  props: {
    studioInfoData: {
      type: String,
      require: true,
    },
    studioTagInfoData: {
      type: String,
      require: true,
    },
    imagesString: {
      type: String,
      require: true,
    },
    flagsData: {
      type: String,
      require: true,
    },
    index: {
      type: String,
      require: true,
    },
    count: {
      type: String,
      require: true,
    },
    sort: {
      type: String,
      require: false,
      default: () => "1",
    },
    imgPath: {
      type: String,
      require: true,
    },
    nonce: {
      type: String,
      require: true,
    },
    postUrl: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      isOpen: false,
      scrollTop: 0,
      scrollpos: 0,
    };
  },
  computed: {
    studioInfo() {
      return JSON.parse(this.studioInfoData);
    },
    studioTagInfo() {
      return JSON.parse(this.studioTagInfoData);
    },
    flags() {
      return JSON.parse(this.flagsData);
    },
    images() {
      return this.imagesString ? this.imagesString.split(",") : [];
    },
  },
  mounted() {
    // console.log(this.postUrl);
  },
  methods: {
    copy(item, value) {
      document.getElementById(value).style.display = "initial";
      setTimeout(() => {
        document.getElementById(value).style.display = "none";
      }, 500);
      navigator.clipboard.writeText(item);
    },
    click() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.bodyFixedOn();
      } else {
        this.bodyFixedOff();
      }
    },
    bodyFixedOn() {
      this.scrollpos = window.scrollY;
      this.scrollTop = -window.scrollY + "px";
      document.body.style.position = "fixed";
      document.body.style.top = this.scrollTop;
    },
    bodyFixedOff() {
      document.body.removeAttribute("style");
      scrollTo(0, this.scrollpos);
    },
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  will-change: opacity;
  transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.trigger {
  cursor: pointer;
}
</style>
